import React, { useEffect, useState } from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { X } from 'lucide-react';
export function ExitIntentPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasTriggered, setHasTriggered] = useState(false);
  const {
    currentPrice,
    checkoutLink,
    offerState
  } = useCountdown();
  useEffect(() => {
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0 && !hasTriggered && offerState !== 'EXPIRED') {
        setIsVisible(true);
        setHasTriggered(true);
      }
    };
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, [hasTriggered, offerState]);
  if (!isVisible) return null;
  return <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-id="element-17">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full relative overflow-hidden animate-[scaleIn_0.3s_ease-out]" data-id="element-18">
        <button onClick={() => setIsVisible(false)} className="absolute top-4 right-4 text-gray-400 hover:text-carbon transition-colors" data-id="element-19">
          <X className="w-6 h-6" data-id="element-20" />
        </button>

        <div className="bg-rojo text-white text-center py-3 font-bold uppercase tracking-wider text-sm" data-id="element-21">
          ¡ESPERA! NO TE VAYAS AÚN
        </div>

        <div className="p-8 text-center" data-id="element-22">
          <h2 className="text-2xl font-playfair font-bold text-marron mb-4" data-id="element-23">
            Tu oferta de ${currentPrice} USD expira pronto.
          </h2>
          <p className="text-carbon mb-6" data-id="element-24">
            ¿Estás segura de que quieres perderla? Una vez que cierres esta
            página, el precio volverá a $29 USD y perderás el acceso a los 6
            bonos de regalo.
          </p>

          <a href={checkoutLink} className="btn-primary w-full h-[56px] text-[16px] mb-4" data-id="element-25">
            ✅ SÍ, QUIERO APROVECHAR EL DESCUENTO →
          </a>

          <button onClick={() => setIsVisible(false)} className="text-sm text-carbon/50 underline hover:text-carbon transition-colors" data-id="element-26">
            No, prefiero pagar el precio completo después
          </button>
        </div>
      </div>
    </div>;
}